function apiUrlBaseGet(urlType) {
    urlType = typeof urlType !== 'undefined' ? urlType : '';
    const url = window.location.href;
    const serverType = serverTypeGet();
    const protocol = window.location.protocol;
    let apiPref = '';
    if ( urlType=='static' ) {
      apiPref = '/static';      
    } else {
      apiPref = '/api/v1';      
    }

    let apiUrlBase;
    let apiPort = 3000;
    apiUrlBase = protocol + '//' + window.location.hostname + ':' + apiPort + apiPref;      

    // if ( serverType=='work' ) {
    //   apiUrlBase = protocol + '//' + window.location.hostname + ':' + apiPort + apiPref;      
    // }
    // else {
    //   apiUrlBase = protocol + '//' + window.location.hostname + apiPref;
    // }
    // apiUrlBase = 'http://localhost:3000/api/v1';
    // console.log('apiUrlBase');
    // console.log(apiUrlBase);

    return apiUrlBase;
    
}

function serverTypeGet() {
    let url = window.location.href;
    let serverType = '';
    if ( url.indexOf(':3001') >= 0 ) {
      serverType = 'work';      
    }
    return serverType;    
}

function apiUrlGet(...addUrlN) {
    let addUrl = addUrlN.join('/');
    let url = apiUrlBaseGet() + (addUrl!=='' ? '/' : '') + addUrl;

    return url;
    
}


export default {apiUrlBaseGet, apiUrlGet};
